<template>
    <b-row>
        <b-col cols="12">
            <b-form-group>
                <v-select @search="fetchDepartmentMembers" v-model="selected"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="fullname" :options="members" multiple
                    class="select-size-lg p-1">
                   
                    <template #option="{ fullname }">
                        <span> {{ fullname }}</span>
                    </template>
                    <template #selected-option="{  fullname }">
                        <span> {{ fullname }}</span>
                    </template>
                </v-select>

            </b-form-group>
        </b-col>
    </b-row>
</template>

<script>
import { BRow, BCol, BFormGroup, BAvatar } from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import axios from '@axios'
export default {
    components: {
        BRow,
        BCol,
        BFormGroup,
        vSelect,
        BAvatar,
    },
    created() {

        // Fetch members when component is created
        if (this.searchOptions && this.searchOptions.id) {
            this.fetchDepartmentMembers(this.searchOptions.id, () => {})
        }
    },
    props: {
        initialMembers: {
            type: Array,
            default: () => []
        },
        searchOptions: {
            type: Object,
            default: () => ({})
        },
        searchType: {
            type: String,
            default: null
        }
    },


    methods: {
        fetchDepartmentMembers(search, loading = () => {}) {
            
            return new Promise((resolve, reject) => {
                var uri = `/admin/f/cm/getmembersbydepartment?id=${search}`;
                if (search ) {
                    loading(true);
                    axios
                        .get(uri)
                        .then((response) => {
                            var data = response.data;
                            var responseData = JSON.parse(JSON.stringify(data));
                            const { data: membersList } = responseData;

                            this.members = membersList;

                            loading(false);
                            resolve(membersList);
                        })
                        .catch(error => {
                            loading(false);
                            reject(error);
                        })
                } else {
                    resolve([]);
                }
            })
        },

    },
    watch: {
        selected: function (newVal, oldVal) {
            this.$emit("selectionChanged", newVal);

        },
        initialMembers: function (newVal, oldVal) {
            this.selected = newVal;

        },
        searchOptions: {
            handler(newVal, oldVal) {
                // When searchOptions changes, fetch members for the new department
                if (newVal && newVal.id) {
                    this.fetchDepartmentMembers(newVal.id, () => {})
                }
            },
            deep: true,
            immediate: false
        }
    },
    data() {
        return {
            members: [],
            options: [],
            selected: this.initialMembers,
        }
    }
}
</script>